'use client';

import { mapBackgroundColor } from '@/helpers/mapBackgroundColor';
import cn from 'classnames';
import { FC, useState } from 'react';
import { TabbedStaticCarouselProps } from '.';
import AnimatedTabButton from './AnimatedTabButton';
import DesktopActiveSlide from './DesktopActiveSlide';
import ImagePreLoader from './ImagePreLoader';
import { getDefaultBackgroundColorName } from './TabbedStaticCarousel.utils';

const TabbedStaticCarouselUnpadded: FC<TabbedStaticCarouselProps> = ({ title, slides = [], showHeader, isOnDark = true, formattingOptions }) => {
  const [activeFeatureIndex, setFeatureIndex] = useState(0);
  const activeFeature = slides[activeFeatureIndex];

  return (
    <div className={cn('flex w-full justify-center flex-col', mapBackgroundColor(formattingOptions?.backgroundColorName ?? getDefaultBackgroundColorName(isOnDark)))}>
      {showHeader && (
        <div className="max-w-grid mx-auto">
          <div
            className="md:col-span-10 md:col-start-2 lg:col-span-8 lg:col-start-3 xl:col-span-8 xl:col-start-3 flex flex-col gap-3">
            <h2 className={cn("font-500 tracking-tight text-30/36 md:text-36/42", {
              "text-white": isOnDark,
            })}>{title}</h2>
          </div>
        </div>
      )}
      <div className="hidden md:flex flex-wrap justify-center w-full max-w-grid mx-auto">
        <ImagePreLoader features={slides} />
        {/* Desktop tab buttons */}
        <div className="flex gap-1 items-center justify-between w-full max-w-[1140px] mb-2 mt-9">
          {slides.map((feature, index) => (
            <AnimatedTabButton
              key={`feature-desktop-nav-${feature.title?.replace(/\s+/g, '-') ?? index}`}
              icon={feature.icon}
              title={feature.title}
              isActive={index === activeFeatureIndex}
              setIsActive={() => setFeatureIndex(index)}
              buttonClass={isOnDark ? `button-drawer-violet` : undefined}
              unselectedTabColor={isOnDark ? `bg-violet-800` : `bg-violet-200`}
            />
          ))}
        </div>
        <DesktopActiveSlide activeFeature={activeFeature} />
      </div>
    </div>
  );
};

export default TabbedStaticCarouselUnpadded;
